import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as router from '@attain-apps/fe/web/main/lib/router'
import * as rxjs from 'rxjs'

import * as admin from '../../admin'
import * as me from '../../me'

import { Api } from './api'
import type { TypeParams } from './types'

/** Connector definitions scoped to the zone selected by the active route. */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    const rawUrl$ = ngCore.inject(router.Router).selectors.rawUrl.asObservable
    const adminZone$ = ngCore.inject(admin.contexts.Feature).selectors
      .zoneContext.asObservable
    const portalZone$ = ngCore.inject(me.Feature).contexts.selectors.zoneContext
      .asObservable
    super({
      api: ngCore.inject(Api),
      context$: rxjs.combineLatest([rawUrl$, adminZone$, portalZone$]).pipe(
        rxjs.map(([url, adminZone, portalZone]) =>
          url === '/admin' || url.startsWith('/admin/')
            ? adminZone
            : portalZone,
        ),
        rxjs.distinctUntilChanged(
          (a, b) => a?.tenantId === b?.tenantId && a?.zoneId === b?.zoneId,
        ),
      ),
      identify: definition => definition.id,
      name: ec.Name.Predefined.IntegrationConnectorDefinition,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory<TypeParams>(collection => ({
            rowConfig: ({ entity: definition }) => ({
              iconsConfigs: [
                {
                  class: 'atn-icon atn-trash atn-red',
                  onClick: () => {
                    collection.plugins.editingPlugin.feature.actions.markForDeletion
                      .from(
                        `IntegrationDefinitions.Table.Row-${definition.id}.Trash.Clicked`,
                      )
                      .dispatch({ id: definition.id })
                  },
                },
              ],
              onClick: () => {
                collection.plugins.editingPlugin.feature.actions.edit
                  .from(
                    `IntegrationDefinitions.Table.Row-${definition.id}.Clicked`,
                  )
                  .dispatch({ id: definition.id })
              },
            }),
            search: true,
          })),
        ],
      },
    })
  }
}
